import { Coordinates } from './../models/coordinates.model';
import { NotificationService } from './notification.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
	
	public getCurrentPosition(): Promise<Coordinates> {
    return new Promise(
			(resolve, reject) => {
				navigator.geolocation.getCurrentPosition(
					(response) => {
						resolve(
							new Coordinates(response.coords.latitude, response.coords.longitude)
						);
					},
					(error) => {
						reject(error);

						this._notificationService.error(error.message);
					}
				);
    	}
		);
  }

  constructor(
		private _notificationService: NotificationService,
	) { }
}
